import Vue from "vue";
import Axios from "axios";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Contact"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.initApp();
        this.setHeader();
        this.setBackgroundColor();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    public static initApp() {
        (<any>window).App.device = {
            isSmartphone: window.matchMedia("screen and (max-width:749px)"),
            isTablet: window.matchMedia("screen and (min-width:750px) and (max-width:1010px)"),
            isRetina: window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)"),
            isUserAgentIOS: navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)/i),
            isUserAgentWinPh: navigator.userAgent.match(/(Windows Phone OS 7)|(IEMobile)/i),
            isUserAgentMobile: navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(Windows Phone OS 7)|(IEMobile)|(webOS)/i)
        };

        (<any>window).addEventListener("resize", this.setPanelSize, true);

        this.setPanelSize();
    }

    public static setPanelSize() {
        let panels = (<any>window).document.querySelectorAll(".panel:not([data-type=\"detail-project\"])");
        for (let i = 0; i < panels.length; i++) {
            panels[i].style.height = (<any>window).document.querySelector(".panel").offsetWidth;
        }

        let panels2 = (<any>window).document.querySelectorAll(".panel[data-valign=\"middle\"]");
        for (let i = 0; i < panels2.length; i++) {
            panels2[i].style["line-height"] = (<any>window).document.querySelector(".panel").offsetWidth + "px";
        }
        //(<any>window).$(".panel").not(".panel[data-type=\"detail-project\"]").height((<any>window).$(".panel").width());
        //(<any>window).$(".panel[data-valign=\"middle\"]").css({ "line-height": (<any>window).$(".panel").width() + "px" });
    }

    private static setHeader() {
        let header = document.getElementById("Header"),
            whatButtonOpen = document.getElementById("WhatOpen"),
            whatButtonClose = document.getElementById("WhatClose"),
            buttonMobile = document.getElementById("ButtonMobile");


        if (whatButtonOpen) {
            whatButtonOpen.addEventListener("click", function () {
                header.classList.add("show-exp");
            });
        }

        if (whatButtonClose) {
            whatButtonClose.addEventListener("click", function () {
                header.classList.remove("show-exp");
            });
        }

        document.addEventListener("click", function (e) {
            if (!document.getElementById("Header").contains(<any>e.target)) {
                header.classList.remove("show-exp");
            }
        });

        if (buttonMobile) {
            buttonMobile.addEventListener("click", function () {
                header.classList.toggle("show");
                document.body.classList.toggle("overflow");
            });
        }

        if (header) {
            window.addEventListener("scroll", function () {
                if (window.scrollY > 0) {
                    header.setAttribute("data-hide", "");
                    document.querySelectorAll(".app-header").forEach(doc => doc.classList.remove("show-exp"));
                } else {
                    header.removeAttribute("data-hide");
                    document.querySelectorAll(".app-header").forEach(doc => doc.classList.remove("show-exp"));
                }
            });

            let posizioneScroll = window.pageYOffset;

            window.addEventListener("scroll", function () {
                if (window.pageYOffset < posizioneScroll) {
                    header.removeAttribute("data-hide");
                }
                posizioneScroll = window.pageYOffset;
            });
        }
    }

    private static setBackgroundColor() {
        window.addEventListener("scroll", (event) => {
            let panel = document.querySelectorAll(".layout"),
                scroll = window.scrollY + (window.screen.height / 3);

            for (var i = 0; i < panel.length; i++) {
                let thisPanel = panel[i];

                if ((<HTMLElement>thisPanel).offsetTop <= scroll && (<HTMLElement>thisPanel).offsetTop + (<HTMLElement>thisPanel).offsetHeight > scroll) {
                    document.body.className = "";
                    document.body.classList.add((<HTMLElement>thisPanel).dataset.layout + "-active");
                }
            };
        });
    }
}